// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var UseLongClick = require("./UseLongClick.bs.js");

function LongClickSpan(props) {
  var match = UseLongClick.useLongClick(props.onClick, props.longClickEnabled, props.longClickDelayMs, props.onShortClick, props.onLongClick);
  return React.createElement("span", {
              style: props.style,
              title: props.title,
              onClick: match.onClick,
              onMouseDown: match.onMouseDown,
              onMouseLeave: match.onMouseLeave,
              onMouseMove: match.onMouseMove,
              onMouseOut: match.onMouseOut,
              onMouseUp: match.onMouseUp,
              onTouchCancel: match.onTouchCancel,
              onTouchEnd: match.onTouchEnd,
              onTouchMove: match.onTouchMove,
              onTouchStart: match.onTouchStart
            }, props.children);
}

var make = LongClickSpan;

exports.make = make;
/* react Not a pure module */
